import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Checkbox,
  TextField,
  Button,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  Tabs,
  Tab,
  FormGroup,
  Input,
  // FormControl,
  IconButton,
  Paper,
  Tooltip,
  List,
  ListItem,
  Chip,
  ListItemText,
  CircularProgress,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Sidebar from "../Drawer/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getSettingsRequest,
  saveSettingsRequest,
  saveBirthdayGiftRequest,
  saveRegistrationGiftRequest,
  bulkGiftRequest,
  addMinQtyRequest,
  addHsnCodeRequest,
  metalRateStatesRequest,
  saveOfferRequest,
  createOrUpdateOfferRequest,
  expireOfferRequest,
} from "../../redux/settings/settingsSlice";
import {
  getConfiguration,
  getAppConfig,
  updateSingleConfigRequest,
} from "../../redux/Configuration/configurationSlice";
import { toast } from "react-toastify";
import { enGB } from "date-fns/locale";
import {
  bulkDiamondPointGiftByFileRequest,
  bulkDiamondPointGiftByPhoneRequest,
} from "../../redux/slices/settingSlice";
import {
  saveDiamondPointsExpireRequest,
  saveDiamondPointsAmountConfigRequest,
} from "../../redux/slices/settingSlice";
import useOfferConfig from "../../redux/Offers/useOfferConfig";
import { fetchOfferConfigRequest } from "../../redux/Offers/OfferSlice";
import { AmountType, controlAllFeatureOptions } from "../../configs/constants";
import { updateConfigRequest } from "../../redux/Configuration/configurationSlice";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs"; //ppp
import { getMetalsRequest } from "../../redux/GetMetals/metalSlice";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReferralOrdersTable from "./ReferralOrdersTable";
import auth from "../../configs/auth";
import { getActiveCountriesRequest } from "../../redux/CountryList/CountrySlice";
import FeatureUnavailable from "../Comman/FeatureUnavailable";
import AccessControl from "../Comman/AccessControl";
import UiArrangementPage from "../MainScreens/UiArrangement/UiArrangementPage";
import { canShowPermission } from "../MainScreens/Permissions/permissionObject";
const Section = ({ title, options, buttonText }) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        width: "100%",
        border: "1px solid #ccc",
      }}
    >
      <Typography fontWeight={700} fontSize={24} mb={3} fontFamily={"Aeonik"}>
        {title}
      </Typography>
      <FormGroup row sx={{ color: "#7B8499" }}>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                sx={{
                  color: "#7b8499", // Unchecked border color
                  "&.Mui-checked": {
                    color: "#4caf50", // Checked color
                  },
                }}
              />
            }
            label={
              <Typography
                variant="body2"
                fontFamily={"Inter"}
                fontSize={"14px"}
                fontWeight={"500"}
                color="#7b8499"
              >
                {option}
              </Typography>
            }
          />
        ))}
      </FormGroup>
      <Button
        variant="contained"
        sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none", mt: 3 }}
      >
        {buttonText}
      </Button>
    </Paper>
  );
};
const Settings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.settingData);
  const metalsdata = data?.data?.metals || [];
  const offers = data?.data?.offers || [];
  const diamondpointstoexpire =
    data?.data?.diamondpointstoexpire?.value ||
    data?.data?.diamondpointstoexpire ||
    {};
  const handleRemoveOffer = (id) => {
    dispatch(expireOfferRequest({ id: id }));
  };
  const configurationData = useSelector(
    (state) => state.appConfig.configurationData,
  );
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const jewellerID = sessionStorage.getItem(auth.selectedJeweller);
  useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller: jewellerID }));
  }, [dispatch]);
  const configData = useSelector((state) => state.appConfig.configData);
  const activeMetals = metalsdata.filter((metal) => metal.status === true);
  const [isSavingbirthgift, setIsSavingBirthgift] = useState(false); //loader for birthgift
  const [isSavingRegistrationGift, setIsSavingRegistrationGift] =
    useState(false); //loader for registration gifts
  const [isSavingServerSide, setIsSavingServerSide] = useState(false);
  const [isSavingBulkGift, setIsSavingBulkGift] = useState(false); //loader for Bulk Diamond Point Gift
  const [isSavingOffer, setIsSavingOffer] = useState(false); // loader for advertisment
  const [isSavingDiamondPoints, setIsSavingDiamondPoints] = useState(false); //loader for Expiring Diamond Points
  const [isSavingState, setIsSavingState] = useState(false); //loader for save state
  const [isSavingDiamondPointsConfig, setIsSavingDiamondPointsConfig] =
    useState(false); //loader forOne Diamond Point Value Configuration
  const [isLoading, setIsLoading] = useState(false); //loader for bulk gift
  const [isLoadingContent, setIsLoadingContent] = useState(false); //loader for save content
  const [isAddingState, setIsAddingState] = useState(false); //loader for add state
  const [editStateIndex, setEditStateIndex] = useState(null);
  const [editStateValue, setEditStateValue] = useState("");
  const [offerFile, setOfferFile] = useState(null);
  const [registrationGiftStatus, setRegistrationGiftStatus] = useState("false");
  const [birthdayGiftStatus, setBirthdayGiftStatus] = useState("false");
  const [referralMsg, setReferralmsg] = useState("");
  const [diamondpointstoexpireData, setDiamondpointstoexpireData] = useState(
    diamondpointstoexpire,
  );
  const [registrationGiftAppStatus, setRegistrationGiftAppStatus] =
    useState(false);
  const [UiArrangementStatus, setUiArrangementStatus] = useState(false);

  const [birthdayGiftAppStatus, setBirthdayGiftAppStatus] = useState(false);
  const [smsCount, setSmsCount] = useState("");
  const [existingBalance, setExistingBalance] = useState(273);
  const [referralPointAmount, setReferralPointAmount] = useState("");
  const [buyFieldInputControl, setBuyFieldInputControl] = useState({
    grams: false,
    amount: false,
  });
  useEffect(() => {
    dispatch(getConfiguration());
    dispatch(getAppConfig());
  }, []);
  useEffect(() => {
    const expireConfig =
      data?.data?.diamondpointstoexpire?.value ||
      data?.data?.diamondpointstoexpire;

    if (!expireConfig || typeof expireConfig !== "object") return;

    setDiamondpointstoexpireData({
      expireUnitType: String(expireConfig.expireUnitType || "").toLowerCase(),
      expireUnit:
        expireConfig.expireUnit !== undefined &&
        expireConfig.expireUnit !== null
          ? String(expireConfig.expireUnit)
          : "",
    });
  }, [data]);

  useEffect(() => {
    const diamondConfig =
      data?.data?.diamondRedeemConfig ||
      data?.data?.data?.diamondRedeemConfig ||
      data?.diamondRedeemConfig ||
      data?.data?.diamondpointsamountconfig?.value ||
      data?.data?.data?.diamondpointsamountconfig?.value ||
      data?.diamondpointsamountconfig?.value ||
      configData?.diamondRedeemConfig ||
      configData?.data?.diamondRedeemConfig ||
      configData?.data?.data?.diamondRedeemConfig;

    if (!diamondConfig || typeof diamondConfig !== "object") return;

    const normalizedAmountType = String(
      diamondConfig.amountType ?? AmountType.Paisa,
    ).toLowerCase();
    const normalizedConfigAmount =
      diamondConfig.configAmount !== undefined &&
      diamondConfig.configAmount !== null
        ? String(diamondConfig.configAmount)
        : "";

    setAmountType(
      normalizedAmountType === AmountType.Rupee
        ? AmountType.Rupee
        : AmountType.Paisa,
    );
    setConfigAmount(normalizedConfigAmount);
  }, [data, configData]);

  useEffect(() => {
    if (Object.keys(configurationData).length) {
      setExistingBalance(configurationData.availableSms ?? 0);
      setReferralPointAmount(configurationData.referralPointAmount ?? 0);
      setRegistrationGiftStatus(
        configurationData.registrationgiftstatus === "true",
      );
      setBirthdayGiftStatus(configurationData.birthdaygiftstatus === "true");
    }
  }, [configurationData]);

  useEffect(() => {
    if (configData?.data?.featureToggle) {
      setRegistrationGiftAppStatus(
        configData.data.featureToggle.registration_gift === true,
      );
      setBirthdayGiftAppStatus(
        configData.data.featureToggle.birthday_gift === true,
      );
    }
  }, [configData]);

  useEffect(() => {
    if (Object.keys(configData).length) {
      setBuyFieldInputControl(configData.buyFieldInputControl || {});
      setUiArrangementStatus(
        configData?.featureToggle?.ui_arrangement === true,
      );
    }
  }, [configData]);

  useEffect(() => {
    if (Object.keys(configData).length) {
      setReferralmsg(configData.referralMsg || "");
    }
  }, [configData]);

  const handelBuyFieldInputControl = () => {
    dispatch(
      updateConfigRequest({
        key: "buyFieldInputControl",
        value: buyFieldInputControl,
      }),
    );
  };

  const handelReferralMessage = () => {
    dispatch(updateConfigRequest({ key: "referralMsg", value: referralMsg }));
  };

  const [invoiceTitle, setInvoiceTitle] = useState({
    Redeem: "",
    Buy: "",
    Sip: "",
    Installment: "",
    GiftReceived: "",
    Sell: "",
  });

  const [selectedType, setSelectedType] = useState("Redeem");

  useEffect(() => {
    if (Object.keys(configData).length) {
      setInvoiceTitle(configData.invoiceTitle);
    }
  }, [configData]);

  const handleInputChange = (e) => {
    setInvoiceTitle((prev) => ({
      ...prev,
      [selectedType]: e.target.value,
    }));
  };

  const handleSaveInvoiceTitle = () => {
    dispatch(updateConfigRequest({ key: "invoiceTitle", value: invoiceTitle }));
  };

  const [stateInput, setStateInput] = useState("");
  const [stateList, setStateList] = useState([]);
  function formatDateTimeLocal(dateString) {
    if (!dateString) return "N/A";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  const handleAddState = () => {
    const trimmed = stateInput.trim();

    if (!trimmed) {
      toast.error("Please enter a valid state!");
      return;
    }

    if (stateList.includes(trimmed)) {
      toast.error("State already exists!");
      return;
    }

    //  Start loader only for Add
    setIsAddingState(true);

    setTimeout(() => {
      setStateList((prev) => [...prev, trimmed]);
      setStateInput("");
      setIsAddingState(false); //  Stop loader
      toast.success("State added successfully!");
    }, 2500);
  };

  const handleSaveState = () => {
    const trimmedInput = stateInput.trim();

    if (!trimmedInput && stateList.length === 0) {
      toast.error("Please add at least one state before saving!");
      return;
    }

    //  Start loader only for Save
    setIsSavingState(true);

    const mergedStates = Array.from(
      new Set([...stateMetalRatesChanges, ...stateList]),
    );

    setTimeout(() => {
      dispatch(metalRateStatesRequest({ value: mergedStates }));
      setStateMetalRatesChanges(mergedStates);
      setStateList([]);
      setIsSavingState(false); //  Stop loader
      toast.success("States saved successfully!");
    }, 1500);
  };
  const handleRemove = (index) => {
    setStateList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditState = (index) => {
    setEditStateIndex(index);
    setEditStateValue(stateMetalRatesChanges[index]);
  };

  const handleUpdateState = () => {
    const updated = [...stateMetalRatesChanges];
    updated[editStateIndex] = editStateValue;
    setStateMetalRatesChanges(updated);
    setEditStateIndex(null);
    setEditStateValue("");
  };

  const handleDeleteFromDBList = (index) => {
    const updated = stateMetalRatesChanges.filter((_, i) => i !== index);
    setStateMetalRatesChanges(updated);
  };

  const [selectedCountry, setSelectedCountry] = useState("");
  const [availableStates, setAvailableStates] = useState([]);
  const [occasion, setOccasion] = useState("");
  const [giftValidity, setGiftValidity] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileList, setMobileList] = useState([]);
  const [metal, setMetal] = useState("");
  const [weight, setWeight] = useState("");
  const [validityDays, setValidityDays] = useState("");
  const [type, setType] = useState("weight");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // bulk gift upload
  const [bulkGiftType, setBulkGiftType] = useState("day");
  const [bulkGiftUnit, setBulkGiftUnit] = useState("");
  const [bulkGiftNote, setBulkGiftNote] = useState("");
  const [bulkGiftFile, setBulkGiftFile] = useState(null);
  const [bulkMetalGiftFile, setBulkMetalGiftFile] = useState(null);
  const [bulkMobileList, setBulkMobileList] = useState([]);
  const [bulkMobile, setBulkMobile] = useState("");
  const [bulkPoints, setBulkPoints] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [editData, setEditData] = useState({ mobile: "", points: "" });
  const [uploadMode, setUploadMode] = useState("file"); // 'phone' or 'file'

  //for diamond points to expire
  const [expireTimeType, setExpireTimeType] = useState("day");
  const [expireTimeUnit, setExpireTimeUnit] = useState("");
  //for diamond points amount configuration
  const [amountType, setAmountType] = useState(AmountType.Paisa);
  const [configAmount, setConfigAmount] = useState("");

  const [isEnabledRegistration, setIsEnabledRegistration] = useState({
    enabled: false,
  });
  const [metalRegistration, setMetalRegistration] = useState("");
  const [weightRegistration, setWeightRegistration] = useState("");
  const [validityDaysRegistration, setValidityDaysRegistration] = useState("");
  const [typeRegistration, setTypeRegistration] = useState("weight");
  const [startDateRegistration, setStartDateRegistration] = useState("");
  const [endDateRegistration, setEndDateRegistration] = useState("");
  const [selectedMetal, setSelectedMetal] = useState(null);

  const [invoiceCode, setInvoiceCode] = useState("");
  const [invoiceFormat, setInvoiceFormat] = useState("");
  const [customFormat, setCustomFormat] = useState("");

  useEffect(() => {
    if (configData?.invoiceNumberFormat) {
      setInvoiceCode(configData.invoiceNumberFormat.invoiceCode || "");

      const format = configData.invoiceNumberFormat.invoiceFormat || "";

      // detect predefined or custom
      if (["currentmonth", "currentyear", "yearmonth"].includes(format)) {
        setInvoiceFormat(format);
        setCustomFormat("");
      } else {
        setInvoiceFormat("other");
        setCustomFormat(format);
      }
    }
  }, [configData]);

  const handleSaveInvoiceFormat = () => {
    let finalFormat = invoiceFormat;

    if (invoiceFormat === "other") {
      finalFormat = customFormat;
    }

    dispatch(
      updateConfigRequest({
        key: "invoiceNumberFormat",
        value: {
          invoiceCode,
          invoiceFormat: finalFormat,
        },
      }),
    );
  };

  const handleRemoveMobile = (number) => {
    setMobileList((prev) => prev.filter((n) => n !== number));
  };
  const handleBulkRemoveMobile = (mobile) => {
    setBulkMobileList((prev) => prev.filter((n) => n.mobile !== mobile));
  };

  const MIN_PHONE_LENGTH = 5;
  const MAX_PHONE_LENGTH = 13;
  const handleBulkGift = () => {
    if (!mobileList) {
      toast.error("Please Enter Mobile Number");
      return;
    }
    if (!selectedMetal) {
      toast.error("Please select a metal.");
      return;
    }

    if (!giftValidity) {
      toast.error("Please Enter Gift Validity");
      return;
    }

    if (!occasion) {
      toast.error("Please Enter Occasion");
      return;
    }

    if (!weight) {
      toast.error("Please Enter weight");
      return;
    }

    const invalidNumbers = mobileList.filter(
      (m) => m.length < MIN_PHONE_LENGTH || m.length > MAX_PHONE_LENGTH,
    );
    if (invalidNumbers.length > 0) {
      toast.error(
        `Mobile numbers must be between ${MIN_PHONE_LENGTH} and ${MAX_PHONE_LENGTH} digits`,
      );
      return;
    }
    //   let metalFormormData;
    //   if(bulkMetalGiftFile){
    //      metalFormormData = new FormData();
    //   metalFormormData.append("sendtype", "File");
    //   metalFormormData.append("phonelist", JSON.stringify(mobileList));
    //   metalFormormData.append("weight", weight );
    //   metalFormormData.append("metalName", selectedMetal.metalName);
    //   metalFormormData.append("purity", selectedMetal.purity);
    //   metalFormormData.append("occasion", occasion);
    //   metalFormormData.append("giftvalidity", Number(giftValidity));
    //   metalFormormData.append("file", bulkMetalGiftFile);

    //   }
    //   else{
    //    metalFormormData = {
    //     sendtype: "phone",
    //     phonelist: JSON.stringify(mobileList),
    //     weight,
    //     metalName: selectedMetal.metalName,
    //     purity: selectedMetal.purity,
    //     occasion,
    //     giftvalidity: Number(giftValidity),
    //   };
    // }
    let sendtype;
    if (bulkMetalGiftFile) {
      sendtype = "file";
    } else {
      sendtype = "phone";
    }
    setIsLoading(true);

    // Dispatch action
    dispatch(
      bulkGiftRequest({
        sendtype: sendtype,
        phonelist: JSON.stringify(mobileList),
        weight,
        metalName: selectedMetal.metalName,
        purity: selectedMetal.purity,
        occasion,
        giftvalidity: Number(giftValidity),
        bulkMetalGiftFile,
      }),
    );

    // Stop loader after 2 seconds (adjust as needed)
    setTimeout(() => {
      setIsLoading(false);
      // toast.success("Gift Uploaded Successfully!");

      // Reset all fields
      setSelectedMetal(null);
      setOccasion("");
      setGiftValidity("");
      setWeight("");
      setBulkGiftFile(null);
      setMobile("");
      setMobileList([]);
      setBulkMetalGiftFile(null);
    }, 2000);
  };

  const handleAddMobile = () => {
    const cleanedMobile = mobile.replace(/\D/g, "").replace(/^0+/, "");
    if (
      cleanedMobile.length >= MIN_PHONE_LENGTH &&
      cleanedMobile.length <= MAX_PHONE_LENGTH &&
      !mobileList.includes(cleanedMobile)
    ) {
      setMobileList((prev) => [...prev, cleanedMobile]);
      setMobile("");
    } else {
      toast.error(
        `Mobile number must be between ${MIN_PHONE_LENGTH} and ${MAX_PHONE_LENGTH} digits`,
      );
    }
  };

  const handleBulkAddMobile = () => {
    const cleanedMobile = bulkMobile.replace(/\D/g, "").replace(/^0+/, "");
    const isDuplicate = bulkMobileList.some(
      (item) => item.mobile === cleanedMobile,
    );
    const isValidMobile =
      cleanedMobile.length >= MIN_PHONE_LENGTH &&
      cleanedMobile.length <= MAX_PHONE_LENGTH;
    const isValidPoints = bulkPoints.trim() !== "" && !isNaN(bulkPoints);

    if (isValidMobile && isValidPoints && !isDuplicate) {
      setBulkMobileList((prev) => [
        ...prev,
        { mobile: cleanedMobile, points: Number(bulkPoints) },
      ]);
      setBulkMobile("");
      setBulkPoints("");
    } else if (!isValidMobile) {
      toast.error(
        `Mobile number must be between ${MIN_PHONE_LENGTH} and ${MAX_PHONE_LENGTH} digits`,
      );
    } else if (isDuplicate) {
      toast.error("Duplicate mobile number");
    } else if (!isValidPoints) {
      toast.error("Points must be a valid number");
    }
  };
  const handleEdit = (index) => {
    setEditIndex(index);
    setEditData({ ...bulkMobileList[index] });
  };

  const handleEditChange = (field, value) => {
    if (field === "mobile") {
      value = value
        .replace(/\D/g, "")
        .replace(/^0+/, "")
        .slice(0, MAX_PHONE_LENGTH);
    } else {
      value = value.replace(/\D/g, "");
    }
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveEdit = () => {
    const isDuplicate = bulkMobileList.some(
      (item, idx) => idx !== editIndex && item.mobile === editData.mobile,
    );
    if (
      editData.mobile.length < MIN_PHONE_LENGTH ||
      editData.mobile.length > MAX_PHONE_LENGTH ||
      isDuplicate
    )
      return;

    setBulkMobileList((prev) =>
      prev.map((item, idx) => (idx === editIndex ? editData : item)),
    );
    setEditIndex(null);
    setEditData({ mobile: "", points: "" });
  };

  const handleCancelEdit = () => {
    setEditIndex(null);
    setEditData({ mobile: "", points: "" });
  };

  const [stateMetalRatesChanges, setStateMetalRatesChanges] = useState([]);
  // Bulk Diamond Point Gift function for file
  const handleBulkDiamondGiftByFileSubmit = async () => {
    if (isSavingBulkGift) return; // prevent multiple clicks

    const trimmedUnit = String(bulkGiftUnit || "").trim();
    const trimmedType = String(bulkGiftType || "").trim();

    if (!trimmedUnit || !trimmedType || !bulkGiftFile) {
      toast.error("Please fill all required fields for file upload");
      return;
    }

    setIsSavingBulkGift(true);

    const formData = new FormData();
    formData.append("type", trimmedType);
    formData.append("unit", trimmedUnit);
    formData.append("note", bulkGiftNote || "");
    formData.append("file", bulkGiftFile);

    const fileFromFormData = formData.get("file");

    if (!fileFromFormData) {
      console.log("❌ File NOT appended to FormData");
    } else {
      console.log("✅ File in FormData:", fileFromFormData.name);
    }
    try {
      let bulkGiftNote1 = bulkGiftNote || "";
      await dispatch(
        bulkDiamondPointGiftByFileRequest({
          trimmedType,
          trimmedUnit,
          bulkGiftNote1,
          bulkGiftFile,
        }),
      );
      toast.success("Bulk Diamond Gift uploaded successfully!");

      // Reset form
      setBulkGiftFile(null);
      setBulkGiftType("day");
      setBulkGiftNote("");
      setBulkGiftUnit("");
    } catch (err) {
      console.error("Failed to upload bulk gift:", err);
      toast.error("Failed to upload bulk diamond gift.");
    } finally {
      setTimeout(() => setIsSavingBulkGift(false), 500);
    }
  };

  const handleBulkDiamondGiftByPhoneSubmit = async () => {
    if (isSavingBulkGift) return;

    const trimmedUnit = String(bulkGiftUnit || "").trim();
    const trimmedType = String(bulkGiftType || "").trim();

    if (!bulkMobileList.length || !trimmedUnit || !trimmedType) {
      toast.error("Please fill all required fields for phone upload");
      return;
    }

    setIsSavingBulkGift(true);

    const data = {
      bulkGiftUnit: Number(trimmedUnit),
      bulkGiftType: trimmedType,
      bulkGiftNote: bulkGiftNote || "",
      bulkMobileList,
    };

    try {
      await dispatch(bulkDiamondPointGiftByPhoneRequest(data));
      toast.success("Bulk Diamond Gift sent successfully!");

      // Reset form
      setBulkMobileList([]);
      setBulkGiftUnit("");
      setBulkGiftType("day");
      setBulkGiftNote("");
      setBulkMobile("");
      setBulkPoints("");
    } catch (err) {
      console.error("Failed to send bulk gift:", err);
      toast.error("Failed to send bulk diamond gift.");
    } finally {
      setTimeout(() => setIsSavingBulkGift(false), 500);
    }
  };

  const handlesaveDiamondPointsExpireRequest = async () => {
    if (isSavingDiamondPoints) return; // prevent double clicks

    //  Trim inputs
    const trimmedUnitType = String(
      diamondpointstoexpireData.expireUnitType || "",
    ).trim();
    const trimmedUnit = String(
      diamondpointstoexpireData.expireUnit || "",
    ).trim();

    //  Validation
    if (!trimmedUnitType || !trimmedUnit) {
      toast.error("Please fill all required fields");
      return;
    }

    setIsSavingDiamondPoints(true);

    try {
      await dispatch(
        saveDiamondPointsExpireRequest({
          expireUnitType: trimmedUnitType,
          expireUnit: Number(trimmedUnit),
          callback: (res) => {
            toast.success("Diamond Points Expiry saved successfully!");
          },
        }),
      );
    } catch (err) {
      console.error("Failed to save diamond points expiry:", err);
      toast.error("Failed to save Diamond Points Expiry.");
    } finally {
      //  Small delay for smoother UX
      setTimeout(() => {
        setIsSavingDiamondPoints(false);
      }, 500);
    }
  };

  const handlesaveDiamondPointsAmountConfig = async () => {
    if (isSavingDiamondPointsConfig) return; // prevent double clicks

    //  Trim inputs
    const trimmedAmountType = String(amountType || "").trim();
    const trimmedConfigAmount = String(configAmount || "").trim();

    //  Validation
    if (!trimmedAmountType || !trimmedConfigAmount) {
      toast.error("Please fill all required fields");
      return;
    }

    setIsSavingDiamondPointsConfig(true);

    try {
      await dispatch(
        saveDiamondPointsAmountConfigRequest({
          amountType: trimmedAmountType,
          configAmount: Number(trimmedConfigAmount),
          callback: (res) => {
            toast.success("Diamond Points Config Amount saved successfully!");
          },
        }),
      );
    } catch (err) {
      console.error("Failed to save Diamond Points Config Amount:", err);
      toast.error("Failed to save Diamond Points Config Amount.");
    } finally {
      //  Small delay for smoother UX
      setTimeout(() => {
        setIsSavingDiamondPointsConfig(false);
      }, 500);
    }
  };

  useEffect(() => {
    const giftingData = data?.data?.birthdaygiftdetails || {};
    setIsEnabled(giftingData?.isEnabled || false);
    setWeight(giftingData?.weight || "");
    setValidityDays(giftingData?.validityDays || "");
    setMetal(giftingData?.metal || "");
    setType(giftingData?.type || "weight");
    setStartDate(
      giftingData?.startDate ? new Date(giftingData.startDate) : null,
    );
    setEndDate(giftingData?.endDate ? new Date(giftingData.endDate) : null);
  }, [data]);

  useEffect(() => {
    const RegistrationgiftingData = data?.data?.registrationgiftdetails || {};
    setIsEnabledRegistration(
      RegistrationgiftingData?.registrationgiftstatus === true ||
        RegistrationgiftingData?.registrationgiftstatus === "true",
    );
    setWeightRegistration(RegistrationgiftingData?.weight || "");
    setValidityDaysRegistration(RegistrationgiftingData?.validity || "");
    setMetalRegistration(RegistrationgiftingData?.bullion || "");
    setTypeRegistration(RegistrationgiftingData?.type || "weight");
    setStartDateRegistration(
      RegistrationgiftingData?.startDate
        ? new Date(RegistrationgiftingData.startDate)
        : null,
    );
    setEndDateRegistration(
      RegistrationgiftingData?.endDate
        ? new Date(RegistrationgiftingData.endDate)
        : null,
    );
    const panStatus = data?.data?.jewellerkycstatus?.pan;
    setKycStatus({ pan: panStatus === true || panStatus === "true" });

    const serverside = data?.data?.serverside?.enabled;
    setServerSideCalc({
      enabled: serverside === true || serverside === "true",
    });

    const states = data?.data?.statemetalrateschanges;
    if (Array.isArray(states)) {
      setStateMetalRatesChanges(states);
    } else {
      setStateMetalRatesChanges([]);
    }
  }, [data]);
  const handleSaveOffer = async () => {
    if (isSavingOffer) return; // prevent double clicks

    //  Validation
    if (!offerFile) {
      toast.error("Offer banner file is required");
      return;
    }
    if (!startDate) {
      toast.error("Start date is required");
      return;
    }
    if (!endDate) {
      toast.error("End date is required");
      return;
    }

    setIsSavingOffer(true);

    try {
      await dispatch(
        saveOfferRequest({
          file: offerFile,
          startDate,
          endDate,
        }),
      );
      toast.success("Offer saved successfully!");
    } catch (err) {
      console.error("Failed to save offer:", err);
      toast.error("Failed to save offer.");
    } finally {
      //  small delay for smooth UX
      setTimeout(() => {
        setIsSavingOffer(false);
      }, 500);
    }
  };
  const handleSaveBirthDayDetails = async () => {
    if (isSavingbirthgift) return; // Prevent multiple calls

    //  Trimmed values
    const trimmedWeight = String(weight).trim();
    const trimmedValidityDays = String(validityDays).trim();
    const trimmedMetal = String(metal).trim();
    const trimmedType = String(type).trim();

    if (startDate && endDate && endDate < startDate) {
      toast.error("End date cannot be earlier than start date.");
      return;
    }

    if (!trimmedWeight) {
      toast.error("Weight is required.");
      return;
    }
    if (!trimmedValidityDays) {
      toast.error("Validity days are required.");
      return;
    }
    if (!trimmedMetal) {
      toast.error("Please select a metal.");
      return;
    }
    if (!trimmedType) {
      toast.error("Please select type");
      return;
    }

    setIsSavingBirthgift(true);

    const payload = {
      key: "birthdaygiftdetails",
      value: {
        isEnabled,
        weight: trimmedWeight,
        validityDays: trimmedValidityDays,
        metal: trimmedMetal,
        type: trimmedType,
        startDate,
        endDate,
      },
    };

    try {
      await dispatch(saveBirthdayGiftRequest(payload));
      // Optional: show success message
      // toast.success("Birthday gift details saved successfully!");
    } catch (err) {
      console.error("Failed to save:", err);
      toast.error("Failed to save birthday gift details.");
    } finally {
      //  Add slight delay before turning off loader
      setTimeout(() => {
        setIsSavingBirthgift(false);
      }, 2500); // half a second delay
    }
  };

  const handleRegistrationgiftdetails = async () => {
    if (isSavingRegistrationGift) return;

    //  Trimmed values
    const trimmedWeight = String(weightRegistration).trim();
    const trimmedValidityDays = String(validityDaysRegistration).trim();
    const trimmedMetal = String(metalRegistration).trim();
    const trimmedType = String(typeRegistration).trim();

    if (
      startDateRegistration &&
      endDateRegistration &&
      endDateRegistration < startDateRegistration
    ) {
      toast.error("End date cannot be earlier than start date.");
      return;
    }

    if (!trimmedWeight) {
      toast.error("Weight is required.");
      return;
    }
    if (!trimmedValidityDays) {
      toast.error("Validity days are required.");
      return;
    }
    if (!trimmedMetal) {
      toast.error("Please select a metal.");
      return;
    }
    if (!trimmedType) {
      toast.error("Please select type");
      return;
    }

    setIsSavingRegistrationGift(true);

    const payload = {
      key: "registrationgiftdetails",
      value: {
        registrationgiftstatus: isEnabledRegistration.toString(),
        weight: trimmedWeight,
        validity: trimmedValidityDays.toString(),
        bullion: trimmedMetal,
        type: trimmedType,
        startDate: startDateRegistration,
        endDate: endDateRegistration,
      },
    };

    try {
      await dispatch(saveRegistrationGiftRequest(payload));
      // toast.success("Registration gift details saved successfully!");
    } catch (err) {
      console.error("Failed to save:", err);
      toast.error("Failed to save registration gift details.");
    } finally {
      //  small delay before hiding loader
      setTimeout(() => {
        setIsSavingRegistrationGift(false);
      }, 500);
    }
  };

  useEffect(() => {
    if (data?.metals?.length > 0) {
      setMetal(data.metals[0]._id);
    }
  }, [data?.metals]);

  useEffect(() => {
    dispatch(getSettingsRequest());
  }, []);

  useEffect(() => {
    if (data && data.contents) {
      setContentList(data.contents);
    }
  }, [data]);

  const [kycStatus, setKycStatus] = useState({
    pan: false,
  });

  const handleKycChange = (event) => {
    setKycStatus({ ...kycStatus, pan: event.target.checked });
  };

  const handleKycSave = () => {
    dispatch(
      saveSettingsRequest({
        key: "jewellerkycstatus",
        value: { pan: kycStatus.pan.toString() },
      }),
    );
  };

  const [isEnabled, setIsEnabled] = useState({ enabled: false });
  const handleEnabledChange = (event) => {
    setIsEnabled({ ...isEnabled, enabled: event.target.checked });
  };
  const handleEnabledSave = () => {
    dispatch(
      saveSettingsRequest({
        key: "birthdaygiftstatus",
        value: { enabled: serverSideCalc.enabled.toString() },
      }),
    );
  };

  const [serverSideCalc, setServerSideCalc] = useState({
    enabled: false,
  });
  const handleServerSideChange = (event) => {
    setServerSideCalc({ ...serverSideCalc, enabled: event.target.checked });
  };

  const handleServerSideSave = () => {
    dispatch(
      saveSettingsRequest({
        key: "serverside",
        value: { enabled: serverSideCalc.enabled.toString() },
      }),
    );
  };

  const [featureType, setFeatureType] = useState("sell");
  const [checkboxStates, setCheckboxStates] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [hsnChecked, setHsnChecked] = useState({});
  const [selectAllHSN, setHSNSelectAll] = useState(false);
  const [input, setInput] = useState(() => {
    return localStorage.getItem("contentInput") || "";
  });
  const [contentList, setContentList] = useState([]);
  const [editValue, setEditValue] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [hsnInputs, setHsnInputs] = useState({});

  const contentsFromApi = data?.data?.contents || [];

  useEffect(() => {
    if (Array.isArray(contentsFromApi) && contentsFromApi.length > 0) {
      setContentList(contentsFromApi);
    }
  }, [contentsFromApi]);

  const startEdit = (index, value) => {
    setEditIndex(index);
    setEditValue(value);
  };

  const cancelEdit = () => {
    setEditIndex(null);
    setEditValue("");
    setInput(""); // Keep TextField clean if edit is canceled
  };

  const handleSaveEdits = (index) => {
    const trimmed = editValue.trim();

    if (!trimmed) {
      toast.error("Content cannot be empty");
      return;
    }

    const updated = [...contentList];
    updated[index] = editValue;
    setContentList(updated);
    cancelEdit();
  };

  const handleDelete = (index) => {
    const updated = contentList.filter((_, i) => i !== index);
    setContentList(updated);
  };

  const handleAddToList = () => {
    const trimmed = input.trim();

    if (!trimmed) {
      toast.error("Content cannot be empty");
      return;
    }

    if (contentList.includes(trimmed)) {
      toast.warning("Content already exists in the list");
      return;
    }

    setContentList([...contentList, trimmed]);

    // Prefill input with what was added
    setInput(trimmed);

    // Store value in localStorage
    localStorage.setItem("lastContentValue", trimmed);
  };

  const handlePullFromList = () => {
    if (selectedIndex !== null && contentList[selectedIndex]) {
      const pulledValue = contentList[selectedIndex].trim(); // Trim just in case
      setInput(pulledValue);

      setContentList((prev) => prev.filter((_, idx) => idx !== selectedIndex));
      setSelectedIndex(null);
    }
  };

  const handleSave = () => {
    setIsLoadingContent(true);

    // Clean all items
    const cleanedContentList = contentList.map((item) => item.trim());

    dispatch(
      saveSettingsRequest({
        key: "content",
        value: cleanedContentList,
      }),
    );

    //  Stop loader after 2 seconds
    setTimeout(() => {
      setIsLoadingContent(false);
      toast.success("content saved successfully!");
    }, 2000);
  };

  const minQty = data?.data?.minQty || [];
  const [quantities, setQuantities] = useState({});
  const [lastFeatureType, setLastFeatureType] = useState(null);

  useEffect(() => {
    if (
      !Array.isArray(minQty) ||
      minQty.length === 0 ||
      activeMetals.length === 0 ||
      !featureType
    )
      return;

    // Only update quantities when featureType actually changes
    if (lastFeatureType === featureType) return;

    const updatedQuantities = {};

    activeMetals.forEach((metal) => {
      const key = `${metal.metalName}${metal.purity}`;
      const metalGroup = minQty.find((entry) => entry[key]);

      if (metalGroup && Array.isArray(metalGroup[key])) {
        const matchingEntries = metalGroup[key].filter(
          (item) => item.order_type.toLowerCase() === featureType.toLowerCase(),
        );

        if (matchingEntries.length) {
          const latest = matchingEntries.reduce((a, b) =>
            a.updatedAt > b.updatedAt ? a : b,
          );
          updatedQuantities[metal._id] = latest.qty.toString();
        }
      }
    });

    setQuantities(updatedQuantities);
    setLastFeatureType(featureType); // track last used type
  }, [minQty, activeMetals, featureType]);

  const handleQuantityChange = (metalId) => (event) => {
    const inputValue = event.target.value;
    if (/^\d*\.?\d*$/.test(inputValue)) {
      setQuantities((prev) => ({
        ...prev,
        [metalId]: inputValue,
      }));
    }
  };

  const handleSubmit = () => {
    if (!featureType) {
      toast.error("Please select a Feature Type");
      return;
    }
    const payload = {
      qtyList: activeMetals.map((metal) => ({
        bullion: metal._id,
        qty: quantities[metal._id] || "",
        metalName: metal.metalName,
        order_type: featureType.charAt(0).toUpperCase() + featureType.slice(1),
        isSelect: checkboxStates[metal._id] ? "true" : "false",
      })),
    };
    if (payload.qtyList.length === 0) {
      toast.error("Please select at least one metal");
    }
    dispatch(addMinQtyRequest(payload));
  };

  useEffect(() => {
    if (activeMetals.length > 0) {
      const initialHSNInputs = {};

      activeMetals.forEach((metal) => {
        initialHSNInputs[metal._id] = metal.hsnCode?.toString() || "";
      });

      setHsnInputs((prev) => {
        // merge: keep existing edits, only add new metals
        const merged = { ...initialHSNInputs, ...prev };

        // Only update if values actually changed
        const same =
          Object.keys(merged).length === Object.keys(prev).length &&
          Object.keys(merged).every((key) => merged[key] === prev[key]);

        return same ? prev : merged;
      });
    }
  }, [activeMetals]);

  const handleHsnChange = (metalId) => (event) => {
    let inputValue = event.target.value;

    // Allow only digits (no spaces, no negatives)
    const sanitizedValue =
      inputValue === "" ? "" : inputValue.replace(/[^0-9]/g, "");

    setHsnInputs((prev) => ({
      ...prev,
      [metalId]: sanitizedValue,
    }));
  };

  const handleSubmitHSN = () => {
    const payload = {
      qtyList: activeMetals.map((metal) => ({
        bullion: metal._id,
        hsnCode: Number(hsnInputs[metal._id]) || 0,
        metalName: metal.metalName,
        isSelect: hsnChecked[metal._id] ? "true" : "false",
      })),
    };

    if (payload.qtyList.length == 0) {
      toast.error("Please select at least one metal");
      return;
    }
    dispatch(addHsnCodeRequest(payload));
  };

  // Select All toggle
  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    const updatedStates = {};
    activeMetals.forEach((metal) => {
      updatedStates[metal._id] = checked;
    });
    setCheckboxStates(updatedStates);
    setSelectAll(checked);
  };

  const handleHSNSelectAllChange = (event) => {
    const checked = event.target.checked;
    const updatedStates = {};
    activeMetals.forEach((metal) => {
      updatedStates[metal._id] = checked;
    });
    setHsnChecked(updatedStates);
    setHSNSelectAll(checked);
  };

  // Individual checkbox toggle
  const handleCheckboxChange = (id) => (event) => {
    const updated = { ...checkboxStates, [id]: event.target.checked };
    setCheckboxStates(updated);

    // If ALL individual checkboxes are now true, then check selectAll
    const allChecked = activeMetals.every((metal) => updated[metal._id]);
    setSelectAll(allChecked);
  };

  // Individual checkbox toggle
  const handleHSNCheckboxChange = (id) => (event) => {
    const updated = { ...hsnChecked, [id]: event.target.checked };
    setHsnChecked(updated);

    // If ALL individual checkboxes are now true, then check selectAll
    const allChecked = activeMetals.every((metal) => updated[metal._id]);
    setHSNSelectAll(allChecked);
  };
  const metalState = useSelector((state) => state.metal || {});
  const enabledMetals = metalState.data?.metals || [];
  const initialFormData = {
    customerType: "",
    metal: "",
    offerType: "",
    referralType: "",
    metal: "",
    transactionsFrequency: "",
    transactionsType: "",
    percentage: "",
    points: "",
    joinerBullion: "",
    joinerPointsPerGram: "",
    pointsPerGram: "",
    startDate: null,
    endDate: null,
    validityDays: "",
  };

  const [formData1, setFormData1] = useState(initialFormData);

  const [loadingBenfits, setLoadingBenfits] = useState(false);

  useEffect(() => {
    dispatch(getMetalsRequest());
  }, [dispatch]);

  const handelReferralPointAmount = () => {
    if (!referralPointAmount) {
      toast.error("Amount cannot be empty");
      return;
    }

    dispatch(
      updateSingleConfigRequest({
        name: "referralPointAmount",
        value: referralPointAmount,
      }),
    );
  };

  const handleChange = (field, value) => {
    setFormData1((prev) => ({ ...prev, [field]: value }));
  };
  const handleSubmit1 = () => {
    if (!formData1.referralType || !formData1.transactionsFrequency) {
      toast.error(
        "Please fill referralType and transactionsFrequency required fields!",
      );
      return;
    }

    if (!formData1.startDate || !formData1.endDate) {
      toast.error("Please select both start and end dates!");
      return;
    }

    if (!formData1.validityDays) {
      toast.error("Please enter validity days!");
      return;
    }

    if (Number(formData1.validityDays) <= 0) {
      toast.error("Validity days must be greater than 0!");
      return;
    }

    if (dayjs(formData1.startDate).isAfter(dayjs(formData1.endDate))) {
      toast.error("Start date must be earlier than end date!");
      return;
    }

    if (
      formData1.joinerPointsPerGram !== "" &&
      formData1.joinerPointsPerGram !== null &&
      Number(formData1.joinerPointsPerGram) < 0
    ) {
      toast.error("Joiner Points Per Gram cannot be negative!");
      return;
    }
    const payload = {
      referralType: formData1.referralType?.trim(),
      bullion: formData1.metal?.trim(),
      joinerBullion: formData1.joinerBullion?.trim(),
      transactionsFrequency: formData1.transactionsFrequency?.trim(),
      transactionsType: formData1.transactionsType?.trim(),
      percentage: formData1.percentage ? Number(formData1.percentage) : null,
      joinerPointsPerGram: formData1.joinerPointsPerGram
        ? Number(formData1.joinerPointsPerGram)
        : null,
      points: formData1.points ? Number(formData1.points) : 0,
      pointsPerGram: formData1.pointsPerGram
        ? Number(formData1.pointsPerGram)
        : 0,
      startDate: formData1.startDate
        ? dayjs(formData1.startDate).valueOf()
        : null,
      endDate: formData1.endDate ? dayjs(formData1.endDate).valueOf() : null,
      validityDays: formData1.validityDays
        ? Number(formData1.validityDays)
        : null,
    };

    setLoadingBenfits(true);

    setTimeout(() => {
      dispatch(createOrUpdateOfferRequest(payload));

      setLoadingBenfits(false);
      setFormData1(initialFormData); // reset form
    }, 1000);
  };

  const renderBuyFields = () => (
    <Grid container spacing={2} mt={1}>
      {activeMetals.map((metal) => (
        <Grid item xs={12} md={4} key={metal._id}>
          <Paper elevation={2} sx={{ p: 2, width: "100%" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkboxStates[metal._id] ? true : false}
                  onChange={handleCheckboxChange(metal._id)}
                />
              }
              label={`${metal.metalName} ${metal.karat}K minimum amount.`}
            />
            <Box
              bgcolor="#752ADA"
              color="white"
              textAlign="center"
              fontWeight={700}
              py={1.5}
              borderRadius={1}
              my={1}
            >
              {`${metal.metalName} ${metal.karat}K (${metal.purity})`}
            </Box>
            <Typography fontWeight={500} mb={1}>
              Amount<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter Amount"
              size="small"
              value={quantities[metal._id] || ""}
              onChange={handleQuantityChange(metal._id)}
            />
          </Paper>
        </Grid>
      ))}
    </Grid>
  );

  const renderSellFields = () => (
    <Grid container spacing={2} mt={1}>
      {activeMetals.map((metal) => (
        <Grid item xs={12} md={4} key={metal._id}>
          <Paper elevation={2} sx={{ p: 2, width: "370px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkboxStates[metal._id] ? true : false}
                  onChange={handleCheckboxChange(metal._id)}
                />
              }
              label={`${metal.metalName} ${metal.karat}K minimum amount.`}
            />
            <Box
              bgcolor="#752ADA"
              color="white"
              textAlign="center"
              fontWeight={700}
              py={1.5}
              borderRadius={1}
              my={1}
            >
              {`${metal.metalName} ${metal.karat}K (${metal.purity})`}
            </Box>
            <Typography fontWeight={500} mb={1}>
              Quantity(gms)<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter Amount"
              size="small"
              value={quantities[metal._id] || ""}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d*\.?\d*$/.test(input)) {
                  handleQuantityChange(metal._id)(e);
                }
              }}
              inputProps={{
                inputMode: "decimal",
                pattern: "^[0-9]*\\.?[0-9]*$",
              }}
            />
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
  const renderHSNFields = () => (
    <Grid container spacing={2} mt={1}>
      {activeMetals.map((metal) => (
        <Grid item xs={12} md={4} key={metal._id}>
          <Paper elevation={2} sx={{ p: 2, width: "370px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={hsnChecked[metal._id] ? true : false}
                  onChange={handleHSNCheckboxChange(metal._id)}
                />
              }
              label={`${metal.metalName} ${metal.karat}K HSN code`}
            />
            <Box
              bgcolor="#752ADA"
              color="white"
              textAlign="center"
              fontWeight={700}
              py={1.5}
              borderRadius={1}
              my={1}
            >
              {`${metal.metalName} ${metal.karat}K (${metal.purity})`}
            </Box>
            <Typography fontWeight={500} mb={1}>
              HSN code<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter HSN code"
              size="small"
              value={hsnInputs[metal._id] || ""}
              onChange={handleHsnChange(metal._id)}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 8,
              }}
            />
          </Paper>
        </Grid>
      ))}
    </Grid>
  );

  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreateSetting = canShowPermission(
    permissions,
    "settingsMain",
    "create",
  );
  const canEdit = canShowPermission(permissions, "settingsMain", "edit");
  const jeweller = canShowPermission(permissions, "jeweller", "view");
  const canDelete = canShowPermission(permissions, "settingsMain", "delete");
  dayjs(startDate).format("YYYY-MM-DD HH:mm");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get("tab");
  const initialTab = tabParam ? parseInt(tabParam, 10) : 0;
  const [mainTab, setMainTab] = useState(initialTab);
  const [subTab, setSubTab] = useState(0);

  useEffect(() => {
    if (tabParam) {
      setMainTab(parseInt(tabParam, 10));
    }
  }, [tabParam]);
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",

          mb: 3,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          fontFamily={"Aeonik"}
          sx={{ fontSize: "24px", fontWeight: 700, p: 2 }}
        >
          Setting
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={mainTab}
            onChange={(e, val) => {
              setMainTab(val);
              setSubTab(0); // reset subtabs
            }}
            sx={{
              borderRight: 1,
              borderColor: "divider",
              minWidth: 180,
              width: "20%",
              maxHeight: "80vh",
              overflowY: "auto",

              "& .MuiTab-root": {
                justifyContent: "flex-start",
                alignItems: "flex-start",
                textAlign: "left",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 600,
                fontStyle: "inherit",
                fontFamily: "initial", // ✅ apply font family to all tabs
              },
              "& .Mui-selected": {
                color: "primary.main",
                backgroundColor: "rgba(25, 118, 210, 0.08)",
                borderLeft: "3px solid",
                borderColor: "primary.main",
              },

              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#bbb",
                borderRadius: "10px",
              },
            }}
          >
            <Tab label={t("settings.manageContent")} />
            {/* <Tab label={t("settings.stateMetalRatesChanges")} /> */}
            <Tab label={t("settings.minimumMetalSetting")} />
            <Tab label={t("settings.hsnCodeSetting")} />
            <Tab label={t("settings.expiringDiamondPoints")} />
            <Tab label={t("settings.oneDiamondPointValueConfig")} />
            <Tab label={t("settings.oneReferralPointValueConfig")} />
            <Tab label={t("settings.serverSideCalculation")} />
            <Tab label={t("settings.kycStatus")} />
            <Tab label={t("settings.referralMessage")} />
            <Tab label={t("settings.invoiceTitle")} />
            <Tab label={t("settings.smsQuantity")} />
            <Tab label={t("appConfig.buyTextFieldControl")} />
          </Tabs>
          <Box sx={{ width: "80%", ml: "10px" }}>
            {/* Manage Content  section*/}
            {mainTab === 0 && jeweller && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
              >
                <>
                  <Typography variant="h5" fontWeight="bold" mb={2}>
                    {t("settings.manageContent")}
                  </Typography>

                  <Box display="flex" alignItems="center" gap={3}>
                    {/* Input Box */}
                    <Box flex={1}>
                      <TextField
                        fullWidth
                        label={t("settings.enterEditContent")}
                        value={input}
                        onChange={(e) => {
                          const value = e.target.value.replace(
                            /[^a-zA-Z ]/g,
                            "",
                          );
                          setInput(value.trimStart());
                        }}
                      />
                      <Typography
                        variant="caption"
                        color="primary"
                        mt={1}
                        display="block"
                      >
                        {t("settings.textNotSaved")}
                      </Typography>
                    </Box>

                    {/* Add/Pull Buttons */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      gap={2}
                      justifyContent="center"
                    >
                      <Tooltip
                        title={t("settings.addToList")}
                        placement="right"
                      >
                        <IconButton
                          sx={{ color: "#752ADA" }}
                          onClick={handleAddToList}
                        >
                          <ArrowForwardIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip
                        title={t("settings.pullFromList")}
                        placement="right"
                      >
                        <IconButton
                          sx={{ color: "#752ADA" }}
                          onClick={handlePullFromList}
                        >
                          <ArrowBackIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>

                    {/* Content List */}
                    <Box flex={1}>
                      <Tooltip
                        title={t("settings.itemsInListSaved")}
                        placement="top"
                      >
                        <List
                          sx={{
                            maxHeight: 200,
                            overflow: "auto",
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                          }}
                        >
                          {contentList.map((item, idx) => (
                            <ListItem
                              key={idx}
                              divider
                              button
                              selected={selectedIndex === idx}
                              onClick={() => setSelectedIndex(idx)}
                              sx={{
                                bgcolor:
                                  selectedIndex === idx ? "#EDE7F6" : "inherit",
                                borderLeft:
                                  selectedIndex === idx
                                    ? "4px solid #752ADA"
                                    : "4px solid transparent",
                                transition: "all 0.2s ease-in-out",
                              }}
                              secondaryAction={
                                editIndex === idx ? (
                                  <>
                                    <IconButton
                                      edge="end"
                                      onClick={() => handleSaveEdits(idx)}
                                      sx={{ color: "green" }}
                                    >
                                      <CheckIcon />
                                    </IconButton>
                                    <IconButton
                                      edge="end"
                                      onClick={cancelEdit}
                                      sx={{ color: "grey" }}
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    <IconButton
                                      edge="end"
                                      onClick={() => startEdit(idx, item)}
                                      sx={{ color: "#1976d2" }}
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton
                                      edge="end"
                                      onClick={() => handleDelete(idx)}
                                      sx={{ color: "red" }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </>
                                )
                              }
                            >
                              {editIndex === idx ? (
                                <TextField
                                  size="small"
                                  fullWidth
                                  value={editValue}
                                  onChange={(e) =>
                                    setEditValue(
                                      e.target.value.replace(/[^a-zA-Z ]/g, ""),
                                    )
                                  }
                                />
                              ) : (
                                <ListItemText primary={item} />
                              )}
                            </ListItem>
                          ))}
                        </List>
                      </Tooltip>
                    </Box>
                  </Box>

                  {/* Save Button */}
                  {(canCreateSetting || canEdit) && (
                    <Box mt={2}>
                      <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{
                          height: "40px",
                          bgcolor: "#752ADA",
                          color: "#fff",
                          textTransform: "none",
                        }}
                      >
                        {isLoadingContent ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Save"
                        )}
                      </Button>
                    </Box>
                  )}
                </>
              </Paper>
            )}

            {/*             State Metal Rates Changes section */}
            {/* State Metal Rates Changes section */}
            {/* {mainTab === 1 && jeweller && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc", mt: 2 }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  State Metal Rates Changes
                </Typography>

                {/* Country Dropdown */}
            {/* <Grid item xs={12} mb={2}>
                  <FormControl fullWidth size="small" sx={{ minWidth: 300 }}>
                    <InputLabel id="country-label">{t("settings.selectCountry")}</InputLabel>
                    <Select
                      labelId="country-label"
                      value={selectedCountry}
                      label={t("settings.selectCountry")}
                      onChange={(e) => {
                        const code = e.target.value;
                        setSelectedCountry(code);

                        // find the states of selected country
                        const found = activeCountries.find(
                          (c) => c.countryCode === code
                        );
                        setAvailableStates(found?.states || []);
                        setStateInput(""); // reset selected state
                      }}
                    >
                      {activeCountries.map((country) => (
                        <MenuItem key={country._id} value={country.countryCode}>
                          {country.countryCode} - {country.countryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> */}

            {/* State Dropdown */}
            {/* <Grid item xs={12}>
                  <FormControl fullWidth size="small" sx={{ minWidth: 300 }}>
                    <InputLabel id="state-label">{t("settings.selectState")}</InputLabel>
                    <Select
                      labelId="state-label"
                      value={stateInput}
                      label={t("settings.selectState")}
                      onChange={(e) => setStateInput(e.target.value)}
                      disabled={!selectedCountry}
                    >
                      {availableStates.map((state, index) => (
                        <MenuItem key={index} value={state}>
                          {state}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      onClick={handleAddState}
                      sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none" }}
                    >
                      {isAddingState ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Add"
                      )}
                    </Button>
                  )}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      onClick={handleSaveState}
                      sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none" }}
                    >
                      {isSavingState ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  )}
                </Box> */}

            {/* Already added states */}
            {/* {stateMetalRatesChanges.length > 0 && (
                  <Box
                    sx={{ mt: 3, display: "flex", gap: 1, flexWrap: "wrap" }}
                  >
                    {stateMetalRatesChanges.map((state, index) => (
                      <Box
                        key={index}
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Chip label={state} color="primary" />
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handleDeleteFromDBList(index)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ))}
                  </Box>
                )} */}

            {/* Newly added temporary states */}
            {/* {stateList.length > 0 && (
                  <Box
                    sx={{ mt: 3, display: "flex", gap: 1, flexWrap: "wrap" }}
                  >
                    {stateList.map((state, index) => (
                      <Chip
                        key={index}
                        label={state}
                        onDelete={() => handleRemove(index)}
                        color="primary"
                      />
                    ))}
                  </Box>
                )}
              </Paper>
            )} */}
            {/*   Minimum Metal Setting section*/}
            {mainTab === 1 && jeweller && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc", mt: 2 }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  {t("settings.minimumMetalSetting")}
                </Typography>

                <FormControl component="fieldset">
                  <FormLabel component="legend">
                    {t("settings.selectFeatureType")}
                    <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                  <RadioGroup
                    row
                    value={featureType}
                    onChange={(e) => setFeatureType(e.target.value)}
                  >
                    <FormControlLabel
                      value="buy"
                      control={<Radio />}
                      label={t("settings.buy")}
                    />
                    <FormControlLabel
                      value="sell"
                      control={<Radio />}
                      label={t("settings.sell")}
                    />
                    <FormControlLabel
                      value="gift"
                      control={<Radio />}
                      label={t("settings.gift")}
                    />
                    <FormControlLabel
                      value="redeem"
                      control={<Radio />}
                      label={t("settings.redeem")}
                    />
                  </RadioGroup>
                </FormControl>

                <Box mt={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    }
                    label={t("settings.selectAll")}
                  />
                </Box>

                {/* Conditional Rendering */}
                {featureType === "buy" && renderBuyFields()}
                {(featureType === "sell" ||
                  featureType === "gift" ||
                  featureType === "redeem") &&
                  renderSellFields()}

                <Box textAlign="right" mt={3}>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none" }}
                      onClick={handleSubmit}
                    >
                      {t("settings.add")}
                    </Button>
                  )}
                </Box>
              </Paper>
            )}
            {/* {HCN CODE section} */}
            {mainTab === 2 && jeweller && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc", mt: 2 }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  {t("settings.hsnCodeSetting")}
                </Typography>
                <Box mt={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectAllHSN}
                        onChange={handleHSNSelectAllChange}
                      />
                    }
                    label={t("settings.selectAll")}
                  />
                </Box>
                {renderHSNFields()}

                <Box textAlign="right" mt={3}>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none" }}
                      onClick={handleSubmitHSN}
                    >
                      {t("settings.add")}
                    </Button>
                  )}
                </Box>
              </Paper>
            )}
            {/* Diamond Points To Expire*/}

            {mainTab === 3 && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc", mt: 2 }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  fontFamily={"Aeonik"}
                >
                  {t("settings.expiringDiamondPoints")}
                </Typography>
                <Typography mb={3}>{t("settings.expireTimeDesc")}</Typography>

                <Grid container spacing={2}>
                  <Grid item size={4}>
                    <TextField
                      select
                      label={
                        <>
                          {t("settings.expireTimeType")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      size="small"
                      value={diamondpointstoexpireData.expireUnitType || ""}
                      onChange={(e) =>
                        setDiamondpointstoexpireData((prev) => ({
                          ...prev,
                          expireUnitType: e.target.value, // update only this key
                        }))
                      }
                      fullWidth
                    >
                      <MenuItem value="day">{t("settings.day")}</MenuItem>
                      <MenuItem value="month">{t("settings.month")}</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item size={4}>
                    <TextField
                      type="number"
                      label={
                        <>
                          {t("settings.expireTimeUnit")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      size="small"
                      value={diamondpointstoexpireData.expireUnit || ""}
                      onChange={(e) =>
                        setDiamondpointstoexpireData((prev) => ({
                          ...prev,
                          expireUnit: e.target.value, // update only this key
                        }))
                      }
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12}>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#752ADA",
                          textTransform: "none",
                        }}
                        onClick={handlesaveDiamondPointsExpireRequest}
                        disabled={isSavingDiamondPoints}
                      >
                        {isSavingDiamondPoints
                          ? t("settings.saving")
                          : t("settings.save")}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            )}
            {/* diamond point conversion */}
            {mainTab === 4 && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "1143px", border: "1px solid #ccc", mt: 2 }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  fontFamily={"Aeonik"}
                >
                  {t("settings.oneDiamondPointValueConfig")}
                </Typography>
                <Typography mb={3}>
                  {t("settings.diamondPointAmountDesc")}
                </Typography>

                <Grid container spacing={2}>
                  <Grid item size={5}>
                    <TextField
                      select
                      label={
                        <>
                          {t("settings.selectAmountUnit")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      size="small"
                      value={amountType}
                      onChange={(e) => setAmountType(e.target.value)}
                      fullWidth
                    >
                      <MenuItem value={AmountType.Paisa}>
                        {t("settings.paisa")}
                      </MenuItem>
                      <MenuItem value={AmountType.Rupee}>
                        {t("settings.rupee")}
                      </MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item size={5}>
                    <TextField
                      type="number"
                      label={
                        <>
                          {t("settings.enterAmount")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      size="small"
                      value={configAmount}
                      onChange={(e) => setConfigAmount(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} mt={2}>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#752ADA",
                        textTransform: "none",
                      }}
                      onClick={handlesaveDiamondPointsAmountConfig}
                      disabled={isSavingDiamondPointsConfig}
                    >
                      {isSavingDiamondPointsConfig
                        ? t("settings.saving")
                        : t("settings.save")}
                    </Button>
                  )}
                </Grid>
              </Paper>
            )}

            {/* Server side calculation and kyc status section */}
            <Box
              sx={{
                display: "flex",
                mt: 3,
                width: "100%",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              {/* Server side calculation Section */}
              {mainTab === 6 && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    {t("settings.serverSideCalculation")}
                  </Typography>
                  <FormGroup row sx={{ color: "#7B8499" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={serverSideCalc.enabled}
                          onChange={handleServerSideChange}
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={"Inter"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color="#7b8499"
                        >
                          {t("settings.enable")}
                        </Typography>
                      }
                    />
                  </FormGroup>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      onClick={handleServerSideSave}
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      disabled={isSavingServerSide}
                    >
                      {isSavingServerSide
                        ? t("settings.saving")
                        : t("settings.save")}
                    </Button>
                  )}
                </Paper>
              )}

              {/* Kyc Status section */}
              {mainTab === 7 && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    {t("settings.kycStatus")}
                  </Typography>
                  <FormGroup row sx={{ color: "#7B8499" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={kycStatus.pan}
                          onChange={handleKycChange}
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={"Inter"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color="#7b8499"
                        >
                          PAN
                        </Typography>
                      }
                    />
                  </FormGroup>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      onClick={handleKycSave}
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              )}
            </Box>
            {/*  Clear Demo Loginand convenience section */}
            <Box
              sx={{
                display: "flex",
                mt: 3,
                width: "100%",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              {/* Clear Demo Login section         */}
              {/* <Paper
            elevation={2}
            sx={{
              p: 3,
              width: "49%",
              border: "1px solid #ccc",
            }}
          >
            <Typography
              fontWeight={700}
              fontSize={24}
              mb={3}
              fontFamily={"Aeonik"}
            >
              Clear Demo Login
            </Typography> */}
              {/* save button */}
              {/* <Button
              variant="contained"
              sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none", mt: 3 }}
            >
              Save
            </Button>
          </Paper> */}
            </Box>
            {mainTab === 8 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    {t("settings.referralMessage")}
                  </Typography>
                  {/*Look Book  Texfield and Button */}
                  <Grid container spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      //label="Look Book "
                      // placeholder="Enter Look Book Here"
                      value={referralMsg}
                      onChange={(e) => setReferralmsg(e.target.value)}
                    />
                  </Grid>
                  {/* add button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handelReferralMessage}
                    >
                      Add
                    </Button>
                  )}
                </Paper>
              </>
            )}
            {mainTab === 9 && (
              <>
                <Paper
                  elevation={2}
                  style={{
                    padding: 20,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    style={{ fontWeight: 700, fontSize: 24, marginBottom: 20 }}
                  >
                    {t("settings.invoiceTitle")}
                  </Typography>

                  <Grid container spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                        disabled={!canEdit}
                      >
                        <MenuItem value="Redeem">Redeem</MenuItem>
                        <MenuItem value="Buy">Buy</MenuItem>
                        <MenuItem value="Sip">Sip</MenuItem>
                        <MenuItem value="Installment">Installment</MenuItem>
                        <MenuItem value="GiftReceived">GiftReceived</MenuItem>
                        <MenuItem value="Sell">Sell</MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      <TextField
                        fullWidth
                        size="small"
                        value={invoiceTitle[selectedType]}
                        onChange={handleInputChange}
                        placeholder={`Enter ${selectedType} value`}
                        disabled={!canEdit}
                      />
                    </Grid>
                  </Grid>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#752ADA",
                        padding: "4px 24px",
                        textTransform: "none",
                      }}
                      onClick={handleSaveInvoiceTitle}
                    >
                      Save
                    </Button>
                  )}

                  <Divider sx={{ my: 5 }} />

                  <Typography
                    style={{ fontWeight: 700, fontSize: 20, marginBottom: 20 }}
                  >
                    Invoice Number Format
                  </Typography>

                  <Grid container spacing={2} alignItems="center">
                    {/* Invoice Code */}
                    <Grid item xs={12} sm={2}>
                      <TextField
                        label="Code"
                        size="small"
                        fullWidth
                        value={invoiceCode}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 4) {
                            setInvoiceCode(value);
                          }
                        }}
                        disabled={!canEdit}
                      />
                    </Grid>

                    {/* Format Dropdown */}
                    <Grid item xs={12} sm={3}>
                      <TextField
                        select
                        label="Invoice Format"
                        size="small"
                        fullWidth
                        value={invoiceFormat}
                        onChange={(e) => setInvoiceFormat(e.target.value)}
                        disabled={!canEdit}
                      >
                        <MenuItem value="currentmonth">Current Month</MenuItem>
                        <MenuItem value="currentyear">Current Year</MenuItem>
                        <MenuItem value="yearmonth">Year + Month</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                        <MenuItem value="">None</MenuItem>
                      </TextField>
                    </Grid>

                    {/* Custom Input (only if OTHER) */}
                    {invoiceFormat === "other" && (
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label="Custom (4-6 digit)"
                          size="small"
                          fullWidth
                          value={customFormat}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "");
                            if (val.length <= 6) setCustomFormat(val);
                          }}
                          disabled={!canEdit}
                        />
                      </Grid>
                    )}
                  </Grid>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#752ADA",
                        padding: "4px 24px",
                        textTransform: "none",
                        marginTop: 20,
                      }}
                      onClick={() => {
                        if (
                          invoiceCode &&
                          (invoiceCode.length < 1 || invoiceCode.length > 4)
                        ) {
                          toast.error("Code must be 1 to 4 characters");
                          return;
                        }

                        if (
                          invoiceFormat === "other" &&
                          (customFormat.length < 4 || customFormat.length > 6)
                        ) {
                          toast.error("Custom format must be 4 to 6 digits");
                          return;
                        }

                        handleSaveInvoiceFormat();
                      }}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 10 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    {t("settings.smsQuantity")}
                  </Typography>
                  {/* Sms quantity textfield */}
                  <Grid container spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      label={`SMS Quantity Available Balance (${existingBalance})`}
                      value={smsCount}
                      disabled
                      sx={{
                        width: "100%",
                        minWidth: { xs: "210px", sm: "332px" },
                      }}
                    />
                  </Grid>
                </Paper>
              </>
            )}

            {mainTab === 11 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    mt: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    {t("appConfig.buyTextFieldControl")}
                  </Typography>
                  {/*Look Book  Texfield and Button */}
                  <Grid container spacing={2}>
                    <FormGroup row sx={{ color: "#7B8499", gap: 7 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={buyFieldInputControl.grams}
                            onChange={(e) =>
                              setBuyFieldInputControl({
                                ...buyFieldInputControl,
                                grams: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Grams"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={buyFieldInputControl.amount}
                            onChange={(e) =>
                              setBuyFieldInputControl({
                                ...buyFieldInputControl,
                                amount: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Amount"
                      />
                    </FormGroup>
                  </Grid>
                  {/* add button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handelBuyFieldInputControl}
                    >
                      Add
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 5 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    mt: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    One Referral Point Value Configuration
                  </Typography>
                  <Grid container spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      label={`One Referral Point Value Configuration`}
                      placeholder="Enter Amount"
                      value={referralPointAmount}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^[1-9][0-9]*$/.test(input) || input === "") {
                          setReferralPointAmount(input.trim());
                        }
                      }}
                      sx={{
                        width: "100%",
                        minWidth: { xs: "210px", sm: "332px" },
                      }}
                    />
                  </Grid>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handelReferralPointAmount}
                    >
                      Add
                    </Button>
                  )}
                </Paper>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
